export const EOriginSource = {
  PORTAL: 'portal',
  APP: 'app',
  HR: 'HR',
  INTEGRATION: 'integration'
} as const;

export type EOriginSource = (typeof EOriginSource)[keyof typeof EOriginSource];
